import { 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Col,
} from "reactstrap";
import { BiError } from "react-icons/bi";

import { withTranslation } from "react-i18next";

const TransferToSkillErroModel = ({
  msg=[],
  isOpen,
  title='',
  handleClickCloseModalRequest,
  backdrop = true,
  t,
}) => {  
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={handleClickCloseModalRequest}
        backdrop={backdrop}
      >
        <ModalHeader>
          <BiError />
          <span className="pl-2">
              {title}
          </span>  
        </ModalHeader>
        <ModalBody>
          {
            msg.map((text)=>(
              <Col className="mt-2">
                {text}
              </Col>
            ))
          } 
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleClickCloseModalRequest}>{t(`Close`)}</Button>
        </ModalFooter>        
      </Modal>
    </>
  );
};

export default withTranslation()(TransferToSkillErroModel);
